var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.12,
    height: 14.219,
    viewBox: "0 0 14.12 14.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-5.495 -5.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M20.4,12.413a5.128,5.128,0,1,0,3.626,1.5A5.127,5.127,0,0,0,20.4,12.413Zm0,1.271a3.861,3.861,0,1,1-2.726,1.131A3.856,3.856,0,0,1,20.4,13.684Z",
    transform: "translate(-7.849 -6.723)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M25.672,33.952l-6.623-2.426-6.623,2.426-.437-1.194,7.06-2.586,7.06,2.586Z",
    transform: "translate(-6.494 -14.044)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e71a24d799cfd3981ffc32c6f2975833.svg";
export { ForwardRef as ReactComponent };